/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------------------------------------------------------------------------
 * PDP add-on box
 *
 * Drives the "Add" button in snippets/product-buy-buttons.liquid. That box sits
 * inside the product form, so the button is type="button" and the add is done
 * here by hand — a submit would have added the main product instead.
 *
 * The success path dispatches "product:added" exactly as documented above, which
 * is what refreshes and opens the mini-cart. The listener is delegated from the
 * document so it survives section re-renders on variant change.
 * ------------------------------------------------------------------------ */
(function () {
  var RESET_DELAY = 2000;

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var button = event.target.closest('[data-addon-add]');

    if (!button || button.hasAttribute('disabled')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);

    if (!variantId) {
      return;
    }

    /* data-addon-label first so Complete the Set can reuse this handler without borrowing the
       add-on's class name for its own button. The class lookup stays as the fallback. */
    var label = button.querySelector('[data-addon-label]') || button.querySelector('.product-addon__button-label');
    var originalText = label ? label.textContent : '';
    var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Add-on could not be added to the cart.');
        }

        return response.json();
      })
      .then(function () {
        if (label) {
          label.textContent = button.getAttribute('data-added-text') || 'Added';
        }

        button.classList.add('is-added');

        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1,
            variant: null,
            button: null,
            productAdded: true
          }
        }));

        /* Back to "Add" afterwards, so a second one can be added if wanted. */
        window.setTimeout(function () {
          if (label) {
            label.textContent = originalText;
          }

          button.classList.remove('is-added');
          button.removeAttribute('disabled');
        }, RESET_DELAY);
      })
      .catch(function () {
        /* On the success path the mini-cart opening ends the loading state; on
           failure nothing else will, so it is ended here. */
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (label) {
          label.textContent = originalText;
        }

        button.removeAttribute('disabled');
      });
  });
})();


/* ---------------------------------------------------------------------------
 * COMPLETE THE SET — keeping the offered set in step with the chosen variant
 *
 * The row in snippets/product-buy-buttons.liquid renders EVERY candidate set and
 * hides all but the one matching the variant the page loaded on. This is what
 * moves that choice when the shopper picks a different finish or size.
 *
 * It has to be done here rather than by re-rendering, because <product-rerender>
 * carries allow-partial-rerender and for a buy-buttons block it replaces only
 * .product-form__payment-container (theme.js:10871-10878). Everything else in
 * that snippet — this row included — survives a variant change untouched, so the
 * server never gets a second chance to pick.
 *
 * The scoring is deliberately identical to the Liquid that picks the first paint,
 * and it matches on WORDS rather than on whole option values. The set is a
 * different product with its own option wording — measured on this store the stud
 * is "Gold * 1 Piece" and the capsule "Gold * 3 Pieces" — so whole-value equality
 * scores those at zero and selecting gold left the silver set showing.
 *
 * Composite score, matched * 100 minus the candidate's own word count, so a tie on
 * matches breaks toward the tighter fit. Without it "Rose Gold * 3 Pieces" ties
 * plain "Gold" whenever gold is selected, purely because it contains the word.
 *
 * Bound on document, not on the form: variant:change bubbles, and a product
 * change replaces the whole block list, which would strand a form-level listener.
 * ------------------------------------------------------------------------ */
(function () {
  if (window.__impuriaCompleteTheSetBound) return;
  window.__impuriaCompleteTheSetBound = true;

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var form = event.detail.formId && document.getElementById(event.detail.formId);
    var section = form && form.closest('[data-section-type="product"]');
    if (!section) return;

    var rows = section.querySelectorAll('[data-cts-option]');
    if (!rows.length) return;

    /* options is the normal shape; option1..3 is the fallback for any variant
       payload that does not carry the array. */
    var options = variant.options && variant.options.length
      ? variant.options
      : [variant.option1, variant.option2, variant.option3];

    /* Split on the same separators the Liquid strips, so both sides agree on what
       counts as a word. */
    function words(value) {
      return String(value === null || value === undefined ? '' : value)
        .toLowerCase()
        .replace(/[\u2022\/,\-]/g, ' ')
        .split(/\s+/)
        .filter(Boolean);
    }

    var selected = [];

    options.forEach(function (value) {
      if (value) selected = selected.concat(words(value));
    });

    var best = null;
    var bestScore = -Infinity;

    rows.forEach(function (row) {
      var tokens = words(row.getAttribute('data-cts-match') || '');
      var matched = 0;

      tokens.forEach(function (token) {
        if (selected.indexOf(token) !== -1) matched += 1;
      });

      var score = matched * 100 - tokens.length;

      if (score > bestScore) {
        bestScore = score;
        best = row;
      }
    });

    /* Toggled both ways, so switching back to a finish that has its own set brings
       that set straight back rather than leaving the last match showing. */
    rows.forEach(function (row) {
      row.hidden = row !== best;
    });

    if (!best) return;

    /* The "just X more" figure. Rendered against the variant the page loaded on, so
       it has to be re-read here for the one actually selected — on a product whose
       variants are not all the same price (Moonlight Butterfly is 35/35/44.99) the
       load-time figure is simply wrong for the others.
     *
     * The amounts are looked up, never calculated: every one was formatted by Liquid
     * in the shopper's presentment currency. Doing the subtraction here would produce
     * a number this script would then have to format itself, which is how a store
     * ends up showing dollars to a shopper checking out in pounds. */
    var subtitle = best.querySelector('.product-cts__subtitle');
    var amountElement = best.querySelector('[data-cts-amount]');
    var amountData = best.querySelector('[data-cts-amounts]');

    if (!subtitle || !amountElement || !amountData) return;

    var amounts;

    try {
      amounts = JSON.parse(amountData.textContent);
    } catch (error) {
      /* A malformed map must not take the row down with it: the set, its price and
         its button are static markup and stay correct whatever happens here. */
      console.warn('Complete the set: could not parse the amount map.', error);
      return;
    }

    var amount = amounts[variant.id];

    /* No entry means the set is not dearer than this variant, so there is no "more"
       to state. Hidden rather than left showing a stale figure, and restored the
       moment a variant that does have one is chosen. */
    subtitle.hidden = !amount;

    if (amount) amountElement.textContent = amount;
  });
})();


/* ---------------------------------------------------------------------------
 * COMPLETE THE SET — the chooser drawer
 *
 * "Upgrade to the set" opens a panel where the shopper picks each of the set's
 * options, sees what they have chosen, and adds it. Adding closes the panel and
 * hands off to the theme's own mini-cart rather than navigating to the cart page.
 * The whole panel is built from a JSON payload the Liquid renders beside it.
 *
 * WHY IT IS BUILT HERE rather than in Liquid: the number of option groups is the
 * number of options the set has. Two today (Color, Post Length), but nothing in
 * this file is written to that number — the groups come from an array, so a set
 * with three or four lays out without a theme change.
 *
 * EVERY PRICE IS A STRING FROM THE PAYLOAD and is never computed or formatted
 * here. Liquid formatted them with `money`, in the shopper's presentment currency
 * and format. Doing that arithmetic in the browser is how a store ends up showing
 * dollars to someone checking out in pounds.
 *
 * THE PANEL IS MOVED TO <body> the first time it opens. position: fixed resolves
 * against the nearest ancestor carrying a transform, not against the viewport, and
 * this markup renders deep inside the product form where an animated ancestor
 * would silently pin a full-screen drawer inside the buy column.
 *
 * SHARED WITH THE ADD-ON BOX. When custom.add_on_variant names more than one
 * variant, that box renders this same drawer — same classes, same data-cts-*
 * hooks — and is picked up here with no code path of its own. Everything below is
 * driven by the payload, so nothing needed to learn what an add-on is; the single
 * exception is the "subject" word in the intro sentence. Two boxes on one page is
 * the expected case: the lookup is scoped by [data-cts], so each trigger finds the
 * drawer inside its own box.
 * ------------------------------------------------------------------------ */
(function () {
  if (window.__impuriaCtsDrawerBound) return;
  window.__impuriaCtsDrawerBound = true;

  var openDrawer = null;

  function state(drawer) {
    if (drawer.__ctsState) return drawer.__ctsState;

    var node = drawer.querySelector('[data-cts-data]');
    if (!node) return null;

    var data;

    try {
      data = JSON.parse(node.textContent);
    } catch (error) {
      /* A malformed payload must not take the page down with it — the row behind
         the drawer is static markup and stays correct. */
      console.warn('Complete the set: could not parse the chooser data.', error);
      return null;
    }

    if (!data.variants || !data.variants.length) return null;

    drawer.__ctsState = {
      data: data,
      /* Opens on the first option set, which is the one the row behind was
         already showing. */
      chosen: data.variants[0].options.slice()
    };

    return drawer.__ctsState;
  }

  /* A candidate matches when every option the caller cares about agrees. Passing a
     null at a position means "any", which is what lets availability be tested one
     option at a time. */
  function find(variants, wanted) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;

      for (var j = 0; j < wanted.length; j++) {
        if (wanted[j] !== null && variants[i].options[j] !== wanted[j]) {
          ok = false;
          break;
        }
      }

      if (ok) return variants[i];
    }

    return null;
  }

  function listSentence(names) {
    if (!names.length) return '';
    if (names.length === 1) return names[0];
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  function render(drawer) {
    var s = state(drawer);
    if (!s) return;

    var data = s.data;
    var current = find(data.variants, s.chosen) || data.variants[0];

    s.chosen = current.options.slice();

    var options = data.options || [];

    var intro = drawer.querySelector('[data-cts-intro]');

    if (intro) {
      /* "set" unless the payload names something else. The add-on box hands this same drawer a
         subject of "add-on", and this sentence is the only place the two differ — everything else
         about the panel, down to the swatches, is shared markup and shared CSS. */
      intro.textContent = 'Select ' + listSentence(options.map(function (o) { return o.name; })) + ' for your ' + (data.subject || 'set') + '.';
    }

    /* ---- the option groups ---- */
    var host = drawer.querySelector('[data-cts-options]');

    if (host) {
      host.innerHTML = '';

      options.forEach(function (option, index) {
        /* Only values an available candidate actually stands behind. The option model comes from
           the SET'S PRODUCT, which may list a finish that has no offered variant — drawing it would
           be a control that can never be satisfied. */
        var offered = option.values.filter(function (entry) {
          return data.variants.some(function (v) { return v.options[index] === entry.value; });
        });

        if (!offered.length) return;

        var group = document.createElement('div');
        group.className = 'product-cts-drawer__group';

        var label = document.createElement('span');
        label.className = 'product-cts-drawer__group-label';
        label.innerHTML = '<span class="product-cts-drawer__group-index">' + (index + 1) + '.</span> ';
        label.appendChild(document.createTextNode(option.name));
        group.appendChild(label);

        var values = document.createElement('div');
        values.className = 'product-cts-drawer__values' + (option.isFinish ? ' product-cts-drawer__values--finish' : '');

        offered.forEach(function (entry) {
          /* Available means: this value, together with everything chosen at the OTHER positions, is
             a combination that exists. */
          var probe = s.chosen.slice();
          probe[index] = entry.value;

          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-cts-drawer__value' + (option.isFinish ? ' product-cts-drawer__value--finish' : '');
          button.setAttribute('aria-pressed', s.chosen[index] === entry.value ? 'true' : 'false');

          /* The label is a span in both cases: on a finish swatch the CSS clips it away so the
             circle is the control, but it has to remain in the DOM or the button has no accessible
             name at all. */
          var text = document.createElement('span');
          text.className = 'product-cts-drawer__value-text';
          text.textContent = entry.label || entry.value;
          button.appendChild(text);

          if (option.isFinish && entry.finish) button.setAttribute('data-finish', entry.finish);
          button.title = entry.label || entry.value;

          if (!find(data.variants, probe)) button.setAttribute('data-unavailable', 'true');

          button.addEventListener('click', function () {
            var wanted = s.chosen.slice();
            wanted[index] = entry.value;

            /* If that combination does not exist, keep the value the shopper just asked for and let
               the other options move to the first combination that does. Refusing the click would
               leave them poking at a dead control with no way to tell which other option is in the
               way. */
            if (!find(data.variants, wanted)) {
              var relaxed = options.map(function (_, i) { return i === index ? entry.value : null; });
              var fallback = find(data.variants, relaxed);
              if (!fallback) return;
              wanted = fallback.options.slice();
            }

            s.chosen = wanted;
            render(drawer);
          });

          values.appendChild(button);
        });

        group.appendChild(values);
        host.appendChild(group);
      });
    }

    /* ---- the summary ---- */
    var preview = drawer.querySelector('[data-cts-preview]');

    if (preview) {
      preview.src = current.image || '';
      preview.alt = current.title + ' — ' + current.options.join(', ');
    }

    var setTitle = drawer.querySelector('[data-cts-set-title]');
    if (setTitle) setTitle.textContent = current.title;

    var setHeadline = drawer.querySelector('[data-cts-set-headline]');

    if (setHeadline) {
      /* Only when it says something the title has not. The headline falls back to the variant title
         in the Liquid, which would otherwise repeat the line directly beneath it. */
      var showHeadline = current.headline && current.headline !== current.title;
      setHeadline.hidden = !showHeadline;
      if (showHeadline) setHeadline.textContent = current.headline;
    }

    var chosen = drawer.querySelector('[data-cts-chosen]');
    if (chosen) chosen.textContent = current.options.join(' · ');

    var price = drawer.querySelector('[data-cts-price]');
    if (price) price.textContent = current.price;

    var compare = drawer.querySelector('[data-cts-compare]');

    if (compare) {
      compare.hidden = !current.compare;
      if (current.compare) compare.textContent = current.compare;
    }

    var save = drawer.querySelector('[data-cts-save]');

    if (save) {
      save.hidden = !current.save;
      if (current.save) save.textContent = 'Save ' + current.save;
    }

    var note = drawer.querySelector('[data-cts-note]');

    if (note) {
      note.hidden = !data.note;
      if (data.note) note.textContent = data.note;
    }

    var ctaPrice = drawer.querySelector('[data-cts-cta-price]');
    if (ctaPrice) ctaPrice.textContent = current.price;

    var cta = drawer.querySelector('[data-cts-submit]');
    if (cta) cta.setAttribute('data-variant-id', current.id);
  }

  function open(drawer) {
    render(drawer);
    drawer.setAttribute('aria-hidden', 'false');
    openDrawer = drawer;

    var first = drawer.querySelector('[data-cts-close]');
    if (first) first.focus();
  }

  function close() {
    if (!openDrawer) return;
    openDrawer.setAttribute('aria-hidden', 'true');
    openDrawer = null;
  }

  function submit(button) {
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId || button.hasAttribute('disabled')) return;

    var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('The set could not be added to the cart.');
        return response.json();
      })
      .then(function () {
        /* The chooser gets out of the way BEFORE the cart opens, or the mini-cart
           slides in over a drawer the shopper would find still sitting there when
           they close it. */
        close();
        button.removeAttribute('disabled');

        /* product:added is the theme's documented hook — it is what refreshes and
           opens the mini-cart, and it is the same event the add-on button fires.
           Passing the quantity matters: the theme uses it to update the count. */
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1,
            variant: null,
            button: null,
            productAdded: true
          }
        }));
      })
      .catch(function () {
        /* On the success path the mini-cart opening ends the loading state; on
           failure nothing else will, so it is ended here. */
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        button.removeAttribute('disabled');
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var trigger = event.target.closest('[data-cts-open]');

    if (trigger) {
      event.preventDefault();

      var box = trigger.closest('[data-cts]');
      if (!box) return;

      var drawer = box.__ctsDrawer;

      if (!drawer) {
        drawer = box.querySelector('[data-cts-drawer]');
        if (!drawer) return;

        box.__ctsDrawer = drawer;
        document.body.appendChild(drawer);
      }

      open(drawer);
      return;
    }

    if (event.target.closest('[data-cts-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var cta = event.target.closest('[data-cts-submit]');

    if (cta) {
      event.preventDefault();
      event.stopPropagation();
      submit(cta);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });
})();
